export default "__VITE_ASSET__ea6a5e20__"